import type React from 'react';
import { useEffect } from 'react';

import { OPTIONS } from './time-select.constants';
import { getSecondOptionsSet } from './time-select.helpers';

type UseTimeSelectProps = {
  hoursOnly?: boolean | null;
  maxTimeWindowInHours?: number;
  nullOptionLabel?: string;
  onChange: (value: string | null) => void;
  selectedValue: string | null;
  startTime?: string | null;
};

type Option = {
  hour: number;
  minute: number;
  text: string;
  value: string | null;
};

type UseTimeSelectReturn = {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  options: Option[];
};

export function useTimeSelect({
  hoursOnly,
  nullOptionLabel,
  maxTimeWindowInHours,
  startTime,
  selectedValue,
  onChange,
}: UseTimeSelectProps): UseTimeSelectReturn {
  let options: Option[] = !startTime ? OPTIONS : getSecondOptionsSet({ startTime, maxTimeWindowInHours });
  options = hoursOnly ? options.filter((option) => option.minute === 0) : options;
  if (nullOptionLabel) {
    options.unshift({ hour: 0, minute: 0, text: nullOptionLabel, value: null });
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value);

  useEffect(() => {
    if (selectedValue && !options.some((option) => option.value === selectedValue)) {
      onChange(null);
    }
  }, [onChange, options, selectedValue]);

  return { handleChange, options };
}
